import type { JSX } from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useRevokeGuardian } from '@/features/guardian/hooks';

/**
 * Revoke is a status transition, never a hard delete (ADR-025: a revoked
 * link "simply stops granting access... never deleted"). The confirmation
 * copy says so explicitly, and re-invitation remains possible afterward.
 */
export function RevokeGuardianButton({
  studentId,
  guardianId,
  invitedEmail,
}: {
  readonly studentId: string;
  readonly guardianId: string;
  readonly invitedEmail: string;
}): JSX.Element {
  const revoke = useRevokeGuardian(studentId);

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button type="button" variant="outline" size="sm" disabled={revoke.isPending}>
          Cabut Akses
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Cabut akses {invitedEmail}?</AlertDialogTitle>
          <AlertDialogDescription>
            Akses akan berhenti segera. Riwayat hubungan ini tetap tersimpan dan tidak dihapus. Wali
            ini dapat diundang kembali kapan saja di kemudian hari.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Batal</AlertDialogCancel>
          <AlertDialogAction
            disabled={revoke.isPending}
            onClick={() => {
              revoke.mutate(guardianId);
            }}
          >
            Cabut Akses
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
